import Url from "url";
import extractDomain from 'extract-domain';
import * as Constants from "./Constants";

class UrlHelper {

    getHref() {
        return window.location.href;
    }
    getDomain() {
        const result = extractDomain(window.location.href);

        if (result) {
            return result;
        }

        return null;
    }

    parseUrl() {
        return Url.parse(this.getHref(), true);
    }

    isSafeUrl(urlText) {
        if (!urlText || typeof(urlText) !== "string") {
            return false;
        }

        const url = Url.parse(urlText, true);
        if (!url || !url.protocol) {
            return false;
        }

        const protocol = url.protocol.toLowerCase();
        const protocolWhitelist = ["http:", "https:"];

        if (protocolWhitelist.indexOf(protocol) >= 0) {
            return true;
        }

        return false;
    }

    sanitizeUrl(urlText) {
        if (this.isSafeUrl(urlText)) {
            return urlText;
        }

        return "";
    }

    getReturnUrl () {
        var href = this.parseUrl();
        const returnUrl = this.getProperty("returnurl", href.query);
        return returnUrl;
    }

    getProperty (prop, obj) {

        prop = (prop + "").toLowerCase();
        for(var p in obj){
            if(obj.hasOwnProperty(p) && prop == (p+ "").toLowerCase()){
                return obj[p];
            }
        }
    }

    getProductNameFromUrl(isProductBar) {
        var href = this.getHref().toLowerCase();

        if (href.indexOf("a=v") > -1) {
            return Constants.ORGANIZATION_PRODUCT_VERIFORM;
        }

        if (href.indexOf("a=q") > -1) {
            return Constants.ORGANIZATION_PRODUCT_QUANTIFI;
        }

        if (href.indexOf("a=s7") > -1) {
            return Constants.ORGANIZATION_PRODUCT_SENTRI7;
        }

        if (href.indexOf("a=s7d") > -1) {
            return isProductBar ? Constants.ORGANIZATION_PRODUCT_SENTRI7 : Constants.ORGANIZATION_PRODUCT_SENTRI7DOCUMENTATION;
        }
        if (href.indexOf("a=pa") > -1) {
            return Constants.ORGANIZATION_PRODUCT_POCADVISOR;
        }
        else {
            return isProductBar ? "" : Constants.ORGANIZATION_PRODUCT_SENTRI7;
        }
    }

    getParameterByName(name) {
        var parameters = this.getQuery();

        // eslint-disable-next-line no-useless-escape
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        var results = regex.exec(parameters);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    getProductCodeFromUrl() {
        return this.getParameterByName("a");
    }

    getVirtualProductFromUrl() {
        return Number(this.getParameterByName("virtualProductId"));
    }

    getVirtualUserFromUrl() {
        return this.getParameterByName("virtualUserId");
    }

    getQuery() {
        var href = this.getHref();
        var index = href.indexOf("?");
        if (index > -1) {
            return href.substr(index);
        }
        return "";
    }

    getIdentifiApiUrl = () => {
        return GlobalSettings.IdentifiApiUrl;
    };

    getIdentifiUrl = () => {
        return GlobalSettings.IdentifiUrl;
    };

    getCentralManagementApiUrl = () => {
        return GlobalSettings.CentralManagementApiUrl;
    }

    getCompleteExternalLoginUrl = (pingFederateUrl) => {
        const targetUrl = this.getIdentifiUrl() + 'AuthActions/CompleteSsoLogin' + this.parseUrl().search;
        return pingFederateUrl + '&TargetResource=' + encodeURIComponent(targetUrl);
    };

    getSetEmailTicketExpiredUrl = () => {
        return `${this.getIdentifiUrl()}${Constants.SetEmailTicketExpiredUrl}`;
    };

    getLogoutUrl = () => {
        return `${this.getIdentifiUrl()}${Constants.LogoutUrl}`;
    };

    getSetPasswordTicketExpiredUrl = () => {
        return `${this.getIdentifiUrl()}${Constants.SetPasswordTicketExpiredUrl}`;
    };

    getUpgradeToVirtualUserTicketExpiredUrl = () => {
        return `${this.getIdentifiUrl()}${Constants.UpgradeToVirtualUserTicketExpiredUrl}`;
    };

    getEmailLoginUrl = () => {
        return `${this.getIdentifiUrl()}${Constants.EmailLoginUrl}`;
    };

    getProductSelectorUrl = () => {
        return `${this.getIdentifiUrl()}${Constants.ProductSelectorUrl}`;
    };

    getResetPasswordTicketExpiredUrl = () => {
        return `${this.getIdentifiUrl()}${Constants.ResetPasswordTicketExpiredUrl}`;
    };
}

export default new UrlHelper;
